import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "./api.service";
import { AppConfig } from "../Utilities/app-config.service";
import { environment as env } from "@env/environment";
const BASE_URL = env.serverUrl;

@Injectable({
  providedIn: "root",
})
export class CommunityService {
  constructor(
    private apiService: ApiService,
    private appConfig: AppConfig,
    public _httpClient: HttpClient
  ) { }

  SharedFeedPostComponent: ISharedFeedPostModel = {
    feedPostList: [],
    hasValue: false,
    scrollPosition: 0,
    pageNumber: 1
  };

  getCommunityPost(groupId, tag, pageNo = 1): Observable<any> {
    return this.apiService.get(
      this.appConfig
        .GetUrl("getCommunityPost")
        .replace("[GROUPID]", groupId)
        .replace("[TAG]", tag) +
      "&pageNo=" +
      pageNo
    );
  }

  deleteCommunityPost(id): Observable<any> {
    return this.apiService.delete(
      this.appConfig.GetUrl("deleteCommunityPost").replace("[POSTID]", id)
    );
  }

  getCommunityPostById(id): Observable<any> {
    return this.apiService.get(
      this.appConfig.GetUrl("getCommunityPostById").replace("[POSTID]", id)
    );
  }

  updateCommunityPost(postData) {
    return this.apiService.put(
      this.appConfig.GetUrl("updateCommunityPost"),
      postData
    );
  }

  postReferral(postData: any): Observable<any> {
    return this._httpClient.post(
      BASE_URL + this.appConfig.GetUrl("createCommunityPost"),
      postData
    );
  }

  shareAnUpdate(postData: any): Observable<any> {
    return this._httpClient.post(
      BASE_URL + this.appConfig.GetUrl("createCommunityPost"),
      postData
    );
  }

  getAssociatedGroups() {
    return this.apiService.get(this.appConfig.GetUrl("getAssociatedGroups"));
  }

  // Feeds
  getAssociatedFeeds() {
    return this.apiService.get(this.appConfig.GetUrl("getAssociatedFeeds"));
  }

  getFeedsList(feedId, pageNo) {
    return this.apiService.get(
      this.appConfig.GetUrl("getFeedList").replace("[FEEDID]", feedId)
      + "?pageNo=" + pageNo
    );
  }

  // Like / Dislike
  likeCommunityPost(postData) {
    return this.apiService.post(
      this.appConfig.GetUrl("likeCommunityPost"),
      postData
    );
  }

  deleteCommunityPostLike(id) {
    return this.apiService.delete(
      this.appConfig.GetUrl("dislikeCommunityPost").replace("[LIKEID]", id)
    );
  }

  // Comment

  getPostComment(postId) {
    return this.apiService.get(
      this.appConfig.GetUrl("getPostComment").replace("[POSTID]", postId)
    );
  }

  createPostComment(postData) {
    return this.apiService.post(
      this.appConfig.GetUrl("createPostComment"),
      postData
    );
  }

  // bookmark

  bookmarkCommunityPost(postData) {
    return this.apiService.post(
      this.appConfig.GetUrl("createBookmark"),
      postData
    );
  }

  deleteCommunityPostBookmark(id) {
    return this.apiService.delete(
      this.appConfig.GetUrl("deleteBookmark").replace("[BOOKMARKID]", id)
    );
  }

  getAllBookmarkedPost() {
    return this.apiService.get(this.appConfig.GetUrl("getAllBookmarkedPost"));
  }

  getReportedPost() {
    return this.apiService.get(this.appConfig.GetUrl("GetReportedPost"));
  }

  // trending post
  getTrendingPots(groupId) {
    return this.apiService.get(
      this.appConfig.GetUrl("trendingPost").replace("[GROUPID]", groupId)
    );
  }

  // trending tags
  getTrendingTags(groupId) {
    return this.apiService.get(
      this.appConfig.GetUrl("trendingTags").replace("[GROUPID]", groupId)
    );
  }

  // get login user
  getLoginUser() {
    return this.apiService.get(this.appConfig.GetUrl("getLoginUser"));
  }

  // Share community post
  shareComunityPost(postID) {
    return this.apiService.post(
      this.appConfig.GetUrl("shareComunityPost").replace("[POSTID]", postID)
    );
  }

  reportCommunityPost(postId) {
    return this.apiService.post(
      this.appConfig.GetUrl("reportCommunityPost").replace("[POSTID]", postId)
    );
  }

  acceptRejectCommunityPost(postData) {
    return this.apiService.post(
      this.appConfig.GetUrl("acceptRejectPost"),
      postData
    );
  }

  muteCommunityPost(postId, isMute) {
    return this.apiService.post(
      this.appConfig.GetUrl("muteCommunityPost").replace("[POSTID]", postId)
        .replace("[ISMUTE]", isMute)
    );
  }

  getGroupNotificationSetting(groupId) {
    return this.apiService.get(
      this.appConfig.GetUrl("getGroupSetting").replace("[GROUPID]", groupId)
    );
  }

  saveGroupNotificationSetting(postData) {
    return this.apiService.post(
      this.appConfig.GetUrl("saveGroupSetting"),
      postData
    );
  }
}

export interface ISharedFeedPostModel {
  feedPostList: any[];
  hasValue: boolean;
  scrollPosition: number;
  pageNumber: number;
}
